import { useMemo } from 'react';

import { IBaseItem, ISanityItem } from '@rbi-ctg/menu';
import { ServiceMode } from 'generated/graphql-gateway';
import { useCart } from 'hooks/use-cart';
import { useFeatureMenu } from 'hooks/use-feature-menu';
import { useMenuContext } from 'state/menu';
import { useServiceModeContext } from 'state/service-mode';

import { existsInEntries } from './utils';

export const useMenuFeatureUpsell = () => {
  const { serviceMode } = useServiceModeContext();
  const { filterForAvailability } = useMenuContext();

  const { cartEntries } = useCart();

  const { featureMenu, featureMenuLoading } = useFeatureMenu();

  const upsellType: string = useMemo(() => {
    switch (serviceMode) {
      case ServiceMode.DELIVERY:
        return 'upsellItemsAtCheckoutDelivery';
      default:
        return 'upsellItemsAtCheckoutRestaurant';
    }
  }, [serviceMode]);

  const items: IBaseItem[] = useMemo(
    () =>
      (featureMenu?.[upsellType] || [])
        .filter(
          (item: IBaseItem) =>
            // Check if doesn't exists in the cart
            !existsInEntries(item, cartEntries) &&
            // Check if is available
            !!filterForAvailability(item as ISanityItem)
        )
        .slice(0, 5),
    [cartEntries, featureMenu, filterForAvailability, upsellType]
  );

  return {
    items,
    loading: featureMenuLoading,
  };
};
